import React from 'react';
import { Helmet } from 'react-helmet';

/** Absolute URL; literal host avoids env-derived strings in meta URLs. */
export const DEFAULT_OG_IMAGE_URL = 'https://circumvent.io/images/circumvent-logo-security.png';

const OG_SITE_NAME = 'Circumvent';

/**
 * Open Graph and Twitter Card tags; keep them aligned with the page <title> and meta description.
 * Must be a sibling of Helmet, not a child: react-helmet drops nested custom components.
 */
export default function SeoSocialTags({
  title,
  description,
  url,
  ogType = 'website',
  articlePublishedTime,
  ogImageUrl = DEFAULT_OG_IMAGE_URL,
}) {
  const isSvgImage = ogImageUrl.toLowerCase().endsWith('.svg');
  const twitterImageUrl = isSvgImage ? DEFAULT_OG_IMAGE_URL : ogImageUrl;

  return (
    <Helmet>
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content={OG_SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImageUrl} />
      {ogType === 'article' && articlePublishedTime ? (
        <meta property="article:published_time" content={articlePublishedTime} />
      ) : null}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={twitterImageUrl} />
    </Helmet>
  );
}
